import { useState, useEffect, useRef } from 'react';
import css from './index.module.scss';
import { EFCPAPH5, EFFishTankH5, EFWiFiRouterH5 } from '@/components/UI/svg/river2';
import EFCompare from '@/components/UI/svg/river2/Icon/EFCompare';
import { useGlobal } from '@/utils/useGlobal';
import { getImageSpec } from '@/utils/locals';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

// 视频是否已播放
let hasNoneEnterPlayFlag = true;
const { EFPic } = createEFPic('/media/river2/h5/');
const ICON_ZA_1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none">
        <path
            d="M1.87258 11.367C1.87258 10.5518 2.53341 9.89101 3.34858 9.89101H24.9629V29.1584H3.34858C2.53341 29.1584 1.87258 28.4976 1.87258 27.6824V11.367Z"
            stroke="white"
            strokeWidth="1.12138"
        />
        <rect x="25.0138" y="6.272" width="13.7624" height="27.7797" rx="1.27211" stroke="white" strokeWidth="1.52916" />
        <mask id="path-3-inside-1_137_5489" fill="white">
            <rect x="26.7979" y="10.6046" width="10.1944" height="3.8229" rx="0.63715" />
        </mask>
        <rect x="26.7979" y="10.6046" width="10.1944" height="3.8229" rx="0.63715" stroke="white" strokeWidth="2.5486" mask="url(#path-3-inside-1_137_5489)" />
        <path
            d="M33.1695 27.1705C33.1695 27.8743 32.5989 28.4448 31.8952 28.4448C31.1914 28.4448 30.6208 27.8743 30.6208 27.1705C30.6208 26.4668 31.1914 25.8962 31.8952 25.8962C32.5989 25.8962 33.1695 26.4668 33.1695 27.1705Z"
            fill="white"
        />
        <rect x="10.2321" y="33.542" width="8.9201" height="1.2743" rx="0.63715" fill="white" />
        <path
            d="M14.6921 34.8163C15.044 34.8163 15.3292 34.5311 15.3292 34.1792L15.3292 29.082C15.3292 28.7301 15.044 28.4448 14.6921 28.4448C14.3402 28.4448 14.0549 28.7301 14.0549 29.082L14.0549 34.1792C14.0549 34.5311 14.3402 34.8163 14.6921 34.8163Z"
            fill="white"
        />
    </svg>
);
const ICON_ZA_2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="44" viewBox="0 0 33 44" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6093 1.06305C20.8027 1.06305 24.5992 2.76278 27.3473 5.51088C30.0954 8.25897 31.7951 12.0554 31.7951 16.2489C31.7951 20.4423 30.0954 24.2388 27.3473 26.9869C24.5992 29.735 20.8027 31.4347 16.6093 31.4347C12.4158 31.4347 8.61938 29.735 5.87129 26.9869C3.12319 24.2388 1.42346 20.4423 1.42346 16.2489C1.42346 12.0554 3.12319 8.25897 5.87129 5.51088C8.61938 2.76278 12.4158 1.06305 16.6093 1.06305Z"
            stroke="white"
            strokeWidth="1.76946"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6092 12.4225C17.6658 12.4225 18.6224 12.8508 19.3148 13.5433C20.0073 14.2357 20.4355 15.1923 20.4355 16.2489C20.4355 17.3055 20.0073 18.2621 19.3148 18.9545C18.6224 19.647 17.6658 20.0752 16.6092 20.0752C15.5526 20.0752 14.596 19.647 13.9035 18.9545C13.2111 18.2621 12.7828 17.3055 12.7828 16.2489C12.7828 15.1923 13.2111 14.2357 13.9035 13.5433C14.596 12.8508 15.5526 12.4225 16.6092 12.4225Z"
            stroke="white"
            strokeWidth="1.76946"
        />
        <path
            d="M17.9384 11.8579C19.0633 7.53179 20.2521 5.08576 21.3228 5.38737C22.929 5.8398 25.3536 7.38253 25.0965 9.39351C24.8788 11.0957 22.8578 13.5141 20.3953 15.5646"
            stroke="white"
            strokeWidth="1.76946"
        />
        <path
            d="M19.9993 18.5646C23.766 20.9713 25.725 22.8577 25.1073 23.7829C24.1806 25.1706 21.9642 26.9999 20.1311 26.1339C18.5795 25.4009 16.9039 22.7314 15.7148 19.7558"
            stroke="white"
            strokeWidth="1.76946"
        />
        <path
            d="M12.3358 17.7063C8.20387 19.4114 5.53496 19.934 5.13143 18.8974C4.52614 17.3423 4.29903 14.4775 6.05984 13.4726C7.55026 12.6221 10.698 12.7807 13.8175 13.5133"
            stroke="white"
            strokeWidth="1.76946"
        />
        <path d="M15.2708 31.8119L14.2803 39.7786" stroke="white" strokeWidth="1.76946" />
        <path d="M20.0413 31.7766L21.285 39.7077" stroke="white" strokeWidth="1.76946" />
        <path
            d="M26.9704 39.9819H7.83869C7.04623 39.9819 6.40381 40.6243 6.40381 41.4168C6.40381 42.2092 7.04623 42.8516 7.83869 42.8516H26.9704C27.7629 42.8516 28.4053 42.2092 28.4053 41.4168C28.4053 40.6243 27.7629 39.9819 26.9704 39.9819Z"
            stroke="white"
            strokeWidth="1.76946"
        />
        <path d="M24.61 36.8347V39.5343" stroke="white" strokeWidth="1.76946" strokeLinecap="round" />
    </svg>
);
const ICON_ZA_3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="36" viewBox="0 0 26 36" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.0684 34.6697H3.45065C2.90255 34.6697 2.40629 34.4712 2.04513 34.149C1.68228 33.8253 1.45709 33.3756 1.45709 32.8786V2.9178C1.45709 2.4368 1.66784 1.99932 2.01114 1.67789C2.37399 1.33814 2.88471 1.12589 3.45065 1.12589H23.0684C23.6701 1.12589 24.2097 1.36562 24.5751 1.74508C24.8785 2.05964 25.062 2.46887 25.062 2.9178V32.8786C25.062 33.4084 24.8054 33.8848 24.3992 34.2124C24.0457 34.4964 23.58 34.6697 23.0684 34.6697Z"
            stroke="white"
            strokeWidth="1.24236"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.63947 6.44043V8.8459" stroke="white" strokeWidth="1.24236" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.63947 18.087V22.3633" stroke="white" strokeWidth="1.24236" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.20685 13.6325H25.3844" stroke="white" strokeWidth="1.24236" />
    </svg>
);

export default function J() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'ph']);
    const [isEnterA, setIsEnterA] = useState(false);
    const icons: any = [
        { icon: <EFFishTankH5 width="0.52rem" height="0.52rem" />, text: t('river2.details.sec10_2_icon2') },
        { icon: <EFWiFiRouterH5 width="0.52rem" height="0.52rem" />, text: t('river2.details.sec10_2_icon3') },
    ];
    if (locale !== 'jp') {
        icons.unshift({ icon: <EFCPAPH5 width="0.52rem" height="0.52rem" />, text: t('river2.details.sec10_2_icon1') });
    }
    const videoRefB = useRef();

    const videoMap: any = {
        us: ['/video/river2/details/h5/10_us.webm', '/video/river2/details/h5/10_us.mp4'],
        cn: ['/video/river2/details/h5/10_cn.webm', '/video/river2/details/h5/10_cn.mp4'],
        eu: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        ph: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        de: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        fr: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        it: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        es: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        cis: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
        jp: ['/video/river2/details/h5/10_jp.webm', '/video/river2/details/h5/10_jp.mp4'],
        uk: ['/video/river2/details/h5/10_uk.webm', '/video/river2/details/h5/10_uk.mp4'],
        za: ['/video/river2/details/h5/10_za.webm', '/video/river2/details/h5/10_za.mp4'],
        au: ['/video/river2/details/h5/10_au.webm', '/video/river2/details/h5/10_au.mp4'],
        kr: ['/video/river2/details/h5/10_eu.webm', '/video/river2/details/h5/10_eu.mp4'],
    };

    useEffect(() => {
        const $videoDmo: any = document?.querySelector('#h5MVideoB');
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_details_J .icons',
            triggerHook: 1, // 进入
            offset: 100,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            setIsEnterA(true);
            if ($videoDmo) {
                $videoDmo.currentTime = 0;
                hasNoneEnterPlayFlag = true;
            }
        });
        sceneA1.on('leave', () => {
            setIsEnterA(false);
        });
        sceneA1.addTo(AniContainer);
    }, []);

    // 播放视频
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '#h5MVideoB',
            triggerHook: 0.5, // 进入
            offset: 0,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            if (hasNoneEnterPlayFlag) {
                videoRefB.current?.play();
                hasNoneEnterPlayFlag = false;
            }
        });
        sceneA1.addTo(AniContainer);
    }, []);

    return (
        <div className={`river2_details_J ${css.J_10}`}>
            <div className={`innerBox`}>
                <div className="sec1">
                    <div className="textBox">
                        <p className="guide">{t('river2.details.sec10_1_guide')}</p>
                        <p className="title">{t('river2.details.sec10_1_title')}</p>
                        <p className="desc">
                            {t.rich('river2.details.sec10_1_desc', {
                                h: (h: string) => <span className="h">{h}</span>,
                            })}
                        </p>
                        <div className="compare-info">
                            <p className="river2">{t('river2.details.sec10_1_river2')}</p>
                            <p className="river2-weight">{t('river2.details.sec10_1_river2_weight')}</p>
                            <div className="icon-box">
                                <EFCompare />
                                <span className="icon-other">{t('river2.details.sec10_1_other')}</span>
                                <span className="icon-river2">{t('river2.details.sec10_1_river2')}</span>
                            </div>
                            <p className="other">{t('river2.details.sec10_1_other_ps')}</p>
                            <p className="other-weight">{t('river2.details.sec10_1_other_weight')}</p>
                        </div>
                    </div>
                    <div className="imgBox">
                        <div className="imgBox-in">
                            {locale === 'ph' ? (
                                <img
                                    src="https://websiteoss.ecoflow.com/upload/image/1751079457071/5-m.jpg"
                                    alt={t('river2.details.sec10_1_title')}
                                    aria-label={t('river2.details.sec10_1_title')}
                                />
                            ) : (
                                <EFPic
                                    name={['person.webp', 'person.jpg']}
                                    alt={t('river2.details.sec10_1_title')}
                                    aria-label={t('river2.details.sec10_1_title')}
                                />
                            )}
                        </div>
                    </div>
                </div>
                {/* 增加 us 和 ca 不展示，因为做了优化，不在这个模块展示 */}
                {!['eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'ph'].includes(locale) && (
                    <div className="sec2">
                        <div className="textBox">
                            <p className="red">{t('river2.details.sec10_2_red')}</p>
                            <p className="title">{t('river2.details.sec10_2_title')}</p>
                            <p className="desc">{t('river2.details.sec10_2_desc')}</p>
                            <ul className={`icons${isEnterA ? ' isEnterA' : ''}`}>
                                {locale != 'za' &&
                                    icons?.map((icon: any, k: number) => (
                                        <li className={`iconList iconList-${k}`} key={k}>
                                            <div className="iconList-in">
                                                <div className="icon">{icon?.icon}</div>
                                                <p className="text">{icon?.text}</p>
                                            </div>
                                        </li>
                                    ))}
                                {locale == 'za' && (
                                    <>
                                        <li className="iconList">
                                            <div className="iconList-in">
                                                <div className="icon">
                                                    <ICON_ZA_1 />
                                                </div>
                                                <div className="text">
                                                    <p className="time">
                                                        5 <span className="unit">hr</span>
                                                    </p>
                                                    <p className="device">50" TV 100W</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="iconList">
                                            <div className="iconList-in">
                                                <div className="icon">
                                                    <ICON_ZA_2 />
                                                </div>
                                                <div className="text">
                                                    <p className="time">
                                                        12 <span className="unit">hr</span>
                                                    </p>
                                                    <p className="device">Fan 40W</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="iconList">
                                            <div className="iconList-in">
                                                <div className="icon">
                                                    <ICON_ZA_3 />
                                                </div>
                                                <div className="text">
                                                    <p className="time">
                                                        4.5-9 <span className="unit">hr</span>
                                                    </p>
                                                    <p className="device">Refrigerator 120W</p>
                                                </div>
                                            </div>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                        <div className="imgBox">
                            <EFVideo
                                sources={videoMap[locale] || videoMap.us}
                                width="100%"
                                height="100%"
                                className="fullImgs"
                                loop={false}
                                autoPlay={false}
                                ref={videoRefB}
                                id="h5MVideoB"
                                poster={`/media/river2/h5/J/10_${imgSpec}.jpg`}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
